var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { key: _vm.version, staticClass: "main-search" },
    [
      _c("GlobalSearchLookup", {
        staticClass: "global-search-lookup",
        on: { input: _vm.handleInput }
      }),
      _c(
        "RouterLink",
        { staticClass: "icon", attrs: { to: "/search" } },
        [_c("Icon", { attrs: { name: "search-plus" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }